import { getResolvedRef } from '../../helpers/get-resolved-ref.js';
/**
 * Traverse the OpenAPI operation object and extract all example values.
 *
 * @param operation - The OpenAPI operation object to extract examples from
 */
export const traverseOperationExamples = (operation) => {
    // Add all examples from draft examples
    const examples = new Set(operation['x-draft-examples'] ?? []);
    // Add all examples from request bodies
    if (operation.requestBody) {
        const requestBody = getResolvedRef(operation.requestBody);
        Object.values(requestBody.content ?? {}).forEach((mediaType) => {
            Object.keys(mediaType.examples ?? {}).forEach((key) => {
                examples.add(key);
            });
        });
    }
    // Add all examples from parameters
    if (operation.parameters) {
        operation.parameters.forEach((_parameter) => {
            const parameter = getResolvedRef(_parameter) ?? {};
            if ('content' in parameter && parameter.content) {
                Object.values(parameter.content).forEach((mediaType) => {
                    Object.keys(mediaType.examples ?? {}).forEach((key) => {
                        examples.add(key);
                    });
                });
            }
            if ('examples' in parameter && parameter.examples) {
                Object.keys(parameter.examples ?? {}).forEach((key) => {
                    examples.add(key);
                });
            }
        });
    }
    return Array.from(examples);
};
